import _ from 'lodash';
import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').ActionCode} ActionCode
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * @typedef {Object} GetActionCodesActionOpts
 * @property {string} organization
 * @property {string} searchString
 * @property {string} type
 * @property {boolean} template
 * @property {Object.<string,any>} filter TODO: move to top level fields
 *
 * @callback GetActionCodesAction
 * @param {ActionContext} ctx
 * @param {GetActionCodesActionOpts} opts
 * @returns {Promise<ActionCode[]>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {GetActionCodesAction}
 */
export const getActionCodes = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({ filter: {} }, opts);
  if (!opts.organization) throw new Error(`${nms}: Organization filter is required`);
  if (!opts.type) throw new Error(`${nms}: Type filter is required`);
  if (!~[ 'credit', 'discount' ].indexOf(opts.type)) throw new Error(`${nms}: Invalid type filter '${opts.type}'`);

  const query = {
    type: opts.type,
    $and: [{
      $or: [{ organization: opts.organization }]
    }]
  };

  if (opts.searchString) {
    if (opts.filter.searchBy === 'name') {
      query.$and.push({ name: { $regex: `^${opts.searchString}`, $options: `i` } });
    } else if (opts.filter.searchBy === 'code') {
      query.$and.push({ code: opts.searchString });
    } else {
      query.$and.push({
        $or: [
          { name: { $regex: `^${opts.searchString}`, $options: `i` } },
          { code: opts.searchString }
        ]
      });
    }
  }

  if (opts.template) query.template = true;
  else query.template = { $ne: true };

  if (!_.isEmpty(opts.filter.orgParentId)) {
    query.$and[0].$or.push({ organization: opts.filter.orgParentId, global: true });
  }
  if (!_.isEmpty(opts.filter.orgChildrenIds)) {
    query.$and[0].$or.push({ organization: { $in: opts.filter.orgChildrenIds }, global: true });
  }
  if (!_.isEmpty(opts.filter.orgSiblingsIds)) {
    query.$and[0].$or.push({ organization: { $in: opts.filter.orgSiblingsIds }, global: true });
  }

  if (opts.filter.sellableOnly) query.price = { $exists: true };
  if (opts.filter.unprinted) query.printedAt = { $exists: false };
  if (opts.filter.ungiven) query.givenAt = { $exists: false };
  if (opts.filter.unused) {
    query.usedAt = { $exists: false };
    query.used = { $exists: false };
  }

  if (!_.isEmpty(opts.filter.excludedActionCodes)) {
    query.code = { $nin: opts.filter.excludedActionCodes };
  }

  const codes = await sdk.actionCodes().find(query).then(r => r.items);

  return codes;
};
